// src/lib/apiBaseUrl.ts

/**
 * Base URL de l'API backend (same-origin JWT) — **source unique**.
 *
 * Dérivée des envs Vite (`VITE_API_BASE_URL` > `VITE_BACKEND_URL` > défaut dev).
 * Consommée par `apiClient` (baseUrl du wrapper) ET par les rares `fetch()` blob
 * directs qui ne passent pas par `apiClient` faute de helper binaire :
 * `storageService.downloadFile` et `canvasDraftApi.getDraftContent`. Avant, la
 * même expression était copiée dans ces 3 fichiers — un changement d'env cassait
 * silencieusement celui qu'on oubliait de mettre à jour.
 */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || import.meta.env.VITE_BACKEND_URL || 'http://localhost:3000/api';
